import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import type { VariationSelectionOnSelectHandler } from '../types';

export type OnSelectProps = {
  sku?: string | null;
} & VariationSelectionOnSelectHandler;

export const useVariationFormattedLink = () => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { language, localizeUrl } = useI18n();
  const { push } = useRouter();

  const createLink = (sku: string) => {
    const newSearchParams = new URLSearchParams(searchParams?.toString());

    if (sku) {
      newSearchParams.set('sku', sku);
    }
    return localizeUrl(`${pathname}?${newSearchParams.toString()}`, language);
  };

  const getOnSelectCallback = ({ sku, onSelect }: OnSelectProps) => {
    if (!sku) return () => {};

    if (onSelect) return () => onSelect(sku);

    return () => push(createLink(sku), { scroll: false });
  };

  return { createLink, getOnSelectCallback };
};
